import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CornerDownRightIcon } from 'lucide-react';
import { WorkCard } from './WorkCard';
import { PixelField } from './PixelField';
import { allProjects } from '../utils/projects';

// Two landscape projects per row, five full rows; the rest live on the "All work" page
const FEATURED = 10;
const shown = allProjects.slice(0, FEATURED);
export function Work() {
  return <section id="work" aria-labelledby="work-heading" className="relative isolate px-page pb-20 md:pb-28" data-id="element-386" data-mp="2ds7itj83sm3v">
      {/* Quiet pixel field along the left and right edges, behind the projects */}
      <div className="pointer-events-none absolute inset-0 -z-10 hidden overflow-hidden md:block" aria-hidden="true" data-id="element-387" data-mp="2mqjbrrwfzvzh">
        <PixelField layout="sides" data-id="element-388" data-mp="2rs8i4u8pzlh8" />
      </div>
      <div className="w-full" data-id="element-389" data-mp="21lo8diazlr9">
        <h2 id="work-heading" className="sr-only" data-id="element-390" data-mp="20k2nf3nvgva">
          Selected work
        </h2>

        {/* Header row: quiet label left, "All work" link right */}
        <div className="mb-5 flex items-baseline justify-between gap-6" data-id="element-391" data-mp="1n2vn4xbvwpve">
          <p className="text-[12px] font-medium uppercase tracking-[0.04em] text-fg/60" data-id="element-392" data-mp="1n0sv67r68mo1">
            Selected work{' '}
            <span className="text-fg/40" data-id="element-393" data-mp="1d4piw92lv7nd">({String(shown.length).padStart(2, '0')})</span>
          </p>
          <Link to="/work" className="group inline-flex items-center gap-1.5 text-[13px] tracking-[-0.01em] text-fg transition-opacity duration-150 hover:opacity-70" data-id="element-394" data-mp="185mmte4lsbrj">
            All work
            <span className="text-fg/45" data-id="element-395" data-mp="zd1766w9ql6x">({String(allProjects.length).padStart(2, '0')})</span>
            <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:translate-x-0.5" aria-hidden="true" data-id="element-396" data-mp="udevi1w39d08" />
          </Link>
        </div>

        {/* Two equal landscape columns */}
        <ul className="grid grid-cols-1 gap-x-[var(--gutter)] gap-y-16 md:grid-cols-2 md:gap-y-24" data-id="element-397" data-mp="geozkpl09jdg">
          {shown.map(item => <WorkCard key={item.slug} slug={item.slug} title={item.title} meta={item.summary} image={item.image} tags={item.tags} data-id="element-398" data-mp="5sjxztj5idu9" />)}
        </ul>

        {/* Plain outline button; an enter-style arrow on the left points into the label */}
        <div className="mt-16 flex justify-center md:mt-20" data-id="element-399" data-mp="1tkt28xf6h2t">
          <Link to="/work" className="group inline-flex h-11 items-center gap-3 rounded-control border border-fg/30 px-5 text-[13px] uppercase tracking-[0.04em] text-fg transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:border-fg hover:bg-fg hover:text-bg focus:outline-none focus-visible:ring-2 focus-visible:ring-fg focus-visible:ring-offset-4 focus-visible:ring-offset-bg" data-id="element-400" data-mp="phudb6eziwru">
            <CornerDownRightIcon className="h-4 w-4 transition-transform duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:translate-x-0.5" aria-hidden="true" data-id="element-401" data-mp="18ebz7775k2g6" />
            View all projects
            <span className="opacity-50" data-id="element-402" data-mp="1ikwpl1d1dgt8">({String(allProjects.length).padStart(2, '0')})</span>
          </Link>
        </div>
      </div>
    </section>;
}